import React from "react";
import "./AdminHeader.css";
import { FaQuestionCircle, FaUserCircle } from "react-icons/fa";
import Logo from "../../Assets/LoginScreenAdmin/Logo.png"; // <-- import logo

export default function AdminHeader({ title = "Dashboard" }) {
  return (
    <header className="admin-header">
      <div className="admin-left">
        <div className="admin-logo-box">
          <img src={Logo} alt="logo" className="admin-logo-img" />
        </div>
        <span className="admin-logo-text">Fliplyn</span>
      </div>

      {/* <h2 className="admin-title">{title}</h2> */}

      <div className="admin-right">
        <FaQuestionCircle className="admin-help-icon" />
        <FaUserCircle className="admin-profile-icon" />
      </div>
    </header>
  );
}
